import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *apolloMutation(mutation, $completion) {
  return yield* this.f76().o6b(mutation).h44('Authorization', 'Bearer ' + (yield* this.g76($completion))).p67($completion);
}
function *apolloQuery(query, $completion) {
  return yield* this.f76().n6b(query).h44('Authorization', 'Bearer ' + (yield* this.g76($completion))).p67($completion);
}
var KtorQueryPerformerClass;
function KtorQueryPerformer() {
  if (KtorQueryPerformerClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'KtorQueryPerformer', VOID, VOID, VOID, [1, 0]);
    KtorQueryPerformerClass = $;
  }
  return KtorQueryPerformerClass;
}
//region block: exports
export {
  KtorQueryPerformer as KtorQueryPerformer3enpohylr2sy5,
  apolloMutation as apolloMutation1pfb2yrb4utuy,
  apolloQuery as apolloQuery1ngnajaedsnmj,
};
//endregion

//# sourceMappingURL=KtorQueryPerformer.mjs.map
